// 列表数据结构
const listDataMap = [
  {
    label: '费用结算日期',
    prop: 'day'
  },
  {
    label: '业务发生日期',
    prop: 'actualDay'
  },
  {
    label: '是否跨账期',
    prop: 'hasTransName'
  },
  {
    label: '价格ID',
    prop: 'priceIdName'
  },
  {
    label: '供应商名称',
    prop: 'supplier'
  },
  {
    label: '城市',
    prop: 'city'
  },
  {
    label: 'Region Name',
    prop: 'regionName'
  },
  {
    label: '服务类型',
    prop: 'serviceTypeName'
  },
  {
    label: '计量单位',
    prop: 'unitName'
  },
  {
    label: '结费对象',
    prop: 'costObjectName'
  },
  {
    label: '工作类型',
    prop: 'operationTypeName'
  },
  {
    label: '运载工具',
    prop: 'vehicleName'
  },
  {
    label: '单价(元)',
    prop: 'price'
  },
  {
    label: '结算数量',
    prop: 'workload'
  },
  {
    label: '结算额(元)',
    prop: 'amount'
  },
  {
    label: '舞弊待审核工作量',
    prop: 'unaudittedLoad'
  },
  {
    label: '舞弊工作量',
    prop: 'cheatLoad'
  },
  {
    label: '发票类型',
    prop: 'invoiceTypeName'
  },
  {
    label: '税率(%)',
    prop: 'tax'
  },
  {
    label: '超费金额',
    prop: 'amountExtra'
  }
]

// 详情数据结构
const detailDataMap = [
  {
    label: '人员账号',
    prop: 'phoneNo'
  },
  {
    label: '结费金额(元)',
    prop: 'money'
  },
  {
    label: '班次开始时间',
    prop: 'banciSt'
  },
  {
    label: '班次结束时间',
    prop: 'banciEd'
  },
  {
    label: '是否跨账期',
    prop: 'hasTransName'
  },
  {
    label: '绑定搭档',
    prop: 'partnerPhone'
  },
  {
    label: '有效工作量',
    prop: 'effectiveLoad'
  },
  {
    label: '工作时长',
    prop: 'workTimeName'
  },
  {
    label: '待审核工作量',
    prop: 'unaudittedLoad'
  },
  {
    label: '舞弊工作量',
    prop: 'cheatLoad'
  },
  {
    label: '有效摆车工单数量',
    prop: 'effectiveOrderNo'
  },
  {
    label: '待审核摆车工单数量',
    prop: 'unaudittedOrderNo'
  },
  {
    label: '签收工单ID',
    prop: 'signedOrder'
  },
  {
    label: '备注',
    prop: 'attrs'
  }
]

// 详情附加信息，用于下载
const detailExtraDataMap = [
  {
    label: '费用结算日期',
    prop: 'validDate'
  },
  {
    label: '业务发生日期',
    prop: 'actualDay'
  },
  {
    label: '价格ID',
    prop: 'priceId'
  },
  {
    label: '供应商名称',
    prop: 'supplierName'
  },
  {
    label: '城市',
    prop: 'cityName'
  },
  {
    label: 'Region Name',
    prop: 'regionName'
  },
  {
    label: '服务类型',
    prop: 'serviceTypeName'
  },
  {
    label: '计量单位',
    prop: 'unitName'
  },
  {
    label: '结费对象',
    prop: 'costObjectName'
  },
  {
    label: '工作类型',
    prop: 'operationTypeName'
  },
  {
    label: '运载工具',
    prop: 'vehicleName'
  },
  {
    label: '单价(元)',
    prop: 'price'
  }
]

export { listDataMap, detailDataMap, detailExtraDataMap }
